import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Depot } from '../shared/models/depot.interface';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { Searchable } from '../models/searchable.model';
import { ExternalCredentials } from '@por/shared/core';

@Injectable({
    providedIn: 'root'
})
export class OrganizationService {
    private readonly consumerPortalApi = inject(ConsumerPortalApiService);

    getDepots(orgId: string): Observable<Depot[]> {
        return this.consumerPortalApi.get<Searchable & Depot[]>(`organization-config/${orgId}/depots`).pipe(
            map(data => {
                const response = data as unknown as Depot[];
                return response;
            })
        );
    }

    getExternalCredentials(organizationId: string): Observable<ExternalCredentials[]> {
        return this.consumerPortalApi.get<Searchable & ExternalCredentials[]>(`external-credentials/${organizationId}`).pipe(
            map(data => {
                return data as unknown as ExternalCredentials[];
            })
        );
    }
}
